import { ApiConfig } from './api';
import { fetchWrapper } from './utils/http-utils';

export const create =
  (config: ApiConfig) =>
  (formData: FormData): Promise<any> =>
    fetchWrapper(
      `${config.endpoint}feedback`,
      {
        method: 'POST',
        body: formData,
        headers: {
          'Content-Type': undefined,
        },
      },
      config
    );
